import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { ArrowLeft, Trash2, AlertTriangle } from 'lucide-react';
import DeleteAccountDialog from '@/components/DeleteAccountDialog';
import { useAuth } from '@/lib/AuthContext';

export default function DeleteAccount() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  return (
    <div className="min-h-screen bg-[#0B0D12] text-white pb-20">
      <div className="max-w-2xl mx-auto p-6">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="text-white hover:text-[#6E2BFF] p-2"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="flex items-center gap-3">
            <Trash2 className="w-8 h-8 text-red-500" />
            <h1 className="text-2xl font-bold">Suppression de compte</h1>
          </div>
        </div>

        {/* Content */}
        <Card className="p-6 mb-6 bg-[#13151D] border-[#2A2D3A]">
          <p className="text-[#B3B6C2] leading-relaxed mb-6">
            Pour demander la suppression de votre compte ZNO et des donnees associees :
          </p>

          <ol className="list-decimal list-inside text-[#B3B6C2] space-y-3 mb-6 ml-2">
            <li>Connectez-vous a l'application ZNO</li>
            <li>Rendez-vous dans <span className="text-white font-semibold">Profil → Supprimer mon compte</span></li>
            <li>Confirmez la suppression</li>
          </ol>
        </Card>

        {/* Data deleted */}
        <Card className="p-6 mb-6 bg-[#13151D] border-[#2A2D3A]">
          <h2 className="text-lg font-bold text-white mb-4">Donnees supprimees</h2>
          <ul className="text-[#B3B6C2] space-y-2">
            <li className="flex items-center gap-2">
              <span className="text-red-400">-</span>
              Compte utilisateur
            </li>
            <li className="flex items-center gap-2">
              <span className="text-red-400">-</span>
              Donnees de profil
            </li>
            <li className="flex items-center gap-2">
              <span className="text-red-400">-</span>
              Activite associee au compte
            </li>
          </ul>
        </Card>

        {/* Delay info */}
        <Card className="p-6 mb-8 bg-[#13151D] border-[#2A2D3A]">
          <p className="text-[#B3B6C2] mb-4">
            <span className="text-white font-semibold">Delai :</span> suppression immediate.
          </p>
          <p className="text-[#9CA0AB] text-sm">
            Certaines donnees peuvent etre conservees temporairement pour des obligations legales ou de securite.
          </p>
        </Card>

        {/* Warning */}
        <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 mb-8">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" />
            <p className="text-red-400 text-sm">
              Cette action est irreversible. Toutes vos donnees seront definitivement supprimees.
            </p>
          </div>
        </div>

        {/* Delete button */}
        {user && (
          <Button
            onClick={() => setShowDeleteDialog(true)}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3"
          >
            <Trash2 className="w-5 h-5 mr-2" />
            Supprimer mon compte
          </Button>
        )}

        {!user && (
          <p className="text-center text-[#9CA0AB] text-sm">
            Connectez-vous pour supprimer votre compte.
          </p>
        )}
      </div>

      {/* Delete Account Dialog */}
      <DeleteAccountDialog
        open={showDeleteDialog}
        onOpenChange={setShowDeleteDialog}
      />
    </div>
  );
}
